import BackspaceIcon from '@material-ui/icons/Backspace';

import { DeviationCreate } from './Create/Create';
import { DeviationEdit } from './Edit/Edit';
import { DeviationsList } from './List/List';
import { DeviationShow } from './Show/Show';

export {
	DeviationsList,
	DeviationCreate,
	DeviationEdit,
	DeviationShow
}


export const deviationsResource = {
	list: DeviationsList,
	edit: DeviationEdit,
	show: DeviationShow,
	icon: BackspaceIcon,
}
